export { AvatarBackgroundColorPipe } from './avatar-background-color.pipe';
export { AvatarInitialsPipe } from './avatar-initials.pipe';
export { IsAvatarImagePipe } from './is-avatar-image.pipe';
export { PriorityClassPipe } from './priority-class.pipe';
export { StatusClassPipe } from './status-class.pipe';
export { StatusIconPipe } from './status-icon.pipe';
